import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const TollPlazasPage = lazy(() => import("@/pages/toll-plazas.page"));

export const Route = createFileRoute("/toll-plazas")({
  component: TollPlazasPage,
});
